// extracted by mini-css-extract-plugin
module.exports = {"keyValueEditor":"KeyValueEditor_keyValueEditor__3V3iA","actions":"KeyValueEditor_actions__1nEqz","errors":"KeyValueEditor_errors__1nXWw","footer":"KeyValueEditor_footer__dZpMl"};